var _rect, _circle, _circle2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecoiljs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 2500,
    width: 2368,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "30 11 27.5 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#007af4",
    height: 95,
    rx: 10,
    width: 90
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 18.5,
    fill: "#fff",
    r: 7.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 81.5,
    fill: "#fff",
    r: 7.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.999 25C42.5 37 57.5 34 57.5 42.5c0 5-5.878 6.365-13.501 7C37.999 50 30 50 30 58s16 5.5 13.999 17M34.132 33.353c0 15.289 23.15 18.289 23.15 32.62"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecoiljs);
export default __webpack_public_path__ + "static/media/recoiljs.4331b2a3f7b8d3e36dee210fd148ab36.svg";
export { ForwardRef as ReactComponent };